type LoadDocumentType = {
  type: 'loadDocument';
  url: string;
  filename: string;
  l: string | null;
};

type ChangeColorModeType = {
  type: 'changeColorMode';
  colorMode: string;
};

type AddWatermarkType = {
  type: 'addWatermark';
  mark: string;
  name: string;
  email: string;
  uuid: string;
  time: string;
  shouldRender: boolean;
};

type MapUserIdToDisplayAuthorType = {
  type: 'mapUserIdToDisplayAuthor';
  members: { id: string; name: string }[];
};

type BuildSignableFileType = {
  type: 'buildSignableFile';
  currentFileUrl: string;
};

type VerifyCertificateType = {
  type: 'verifyCertificate';
  approvalCertData: {
    cert: string;
    password: string;
    location?: string;
  };
};

type ProcessSigningType = {
  type: 'processSigning';
  approvalCertData: {
    cert: string;
    password: string;
    location?: string;
  };
  currentFileUrl: string;
  signWithTimestamp: boolean;
  timeStampConfig: {
    tsaUrl: string | null;
    tsaCertUrl: string | null;
  };
};

type JumpToFieldType = {
  type: 'jumpToField';
  position: number;
};

type RemoveSignerFieldsType = {
  type: 'removeSignerFields';
  signerId: string;
};

type AddFieldType = {
  type: 'addField';
  fieldData: {
    fieldType: string;
    fieldName: string;
    pagePoint: { x: number; y: number };
    signerId: string;
    value?: string;
    color: string;
  };
};

type DownloadFileType = {
  type: 'downloadFile';
};

type LoadSavedSignaturesType = {
  type: 'loadSavedSignatures';
};

type PersistSavedSignaturesType = {
  type: 'persistSavedSignatures';
  isEnabled: boolean;
};

type StartSigningType = {
  type: 'startSigning';
};

type CancelSigningType = {
  type: 'cancelSigning';
};

type PostMessageWTCArgs =
  | LoadDocumentType
  | ChangeColorModeType
  | AddWatermarkType
  | MapUserIdToDisplayAuthorType
  | BuildSignableFileType
  | VerifyCertificateType
  | ProcessSigningType
  | JumpToFieldType
  | RemoveSignerFieldsType
  | AddFieldType
  | DownloadFileType
  | LoadSavedSignaturesType
  | PersistSavedSignaturesType
  | StartSigningType
  | CancelSigningType;

const getWebViewerIframe = () => {
  return document.getElementById('web-viewer')?.querySelector('iframe')
    ?.contentWindow;
};

/* Post message from WebViewer to Config */
export function postMessageWTC({ type, ...data }: PostMessageWTCArgs) {
  const iframe = getWebViewerIframe();

  if (iframe) {
    iframe.postMessage({ type: `crdbrd-wtoc-${type}`, ...data }, '*');
  }
}

export function generatePassword(
  length: number = 20,
  wishlist: string = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz~!@-#$',
) {
  return Array.from(crypto.getRandomValues(new Uint32Array(length)))
    .map((x) => wishlist[x % wishlist.length])
    .join('');
}
